// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Canvas_canvas__19898","hideOnSmallScreen":"Canvas_hideOnSmallScreen__2d-RK"};